<template>
  <div
    v-if="REACT_FRONTEND_ENABLED"
    class="sidebar-frontend-switch">
    <div
      role="group"
      aria-label="Interface"
      class="sidebar-frontend-switch__group q-mini-drawer-hide">
      <span
        aria-current="true"
        class="sidebar-frontend-switch__option is-current">
        Classique
      </span>
      <router-link
        :to="reactPath"
        class="sidebar-frontend-switch__option">
        v2
        <q-tooltip v-if="!hasTwin">{{ NO_TWIN_HINT }}</q-tooltip>
      </router-link>
    </div>
    <div class="sidebar-frontend-switch__mini q-mini-drawer-only">
      <q-btn
        flat
        round
        dense
        :icon="symRoundedSwapHoriz"
        :to="reactPath"
        aria-label="Ouvrir la version v2">
        <q-tooltip
          anchor="center right"
          self="center left">
          {{ hasTwin ? 'Version v2' : NO_TWIN_HINT }}
        </q-tooltip>
      </q-btn>
    </div>
  </div>
</template>

<script setup lang="ts">
import { symRoundedSwapHoriz } from '@quasar/extras/material-symbols-rounded'
import { REACT_HOME_PATH, toReactVersionPath } from 'src/router/versionRoutes'
import { REACT_FRONTEND_ENABLED } from 'src/config/releaseFeatures'
import { computed } from 'vue'
import { useRoute } from 'vue-router'

const NO_TWIN_HINT = 'Cette page n’a pas de version v2 : ouvre l’accueil v2'

const route = useRoute()

const twinPath = computed(() => toReactVersionPath(route.fullPath))
const hasTwin = computed(() => twinPath.value !== null)
const reactPath = computed(() => twinPath.value ?? REACT_HOME_PATH)
</script>

<style lang="scss" scoped>
.sidebar-frontend-switch {
  padding: 8px 10px 0;
}

.sidebar-frontend-switch__group {
  display: flex;
  gap: 2px;
  padding: 3px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.06);
}

.sidebar-frontend-switch__option {
  flex: 1 1 0;
  text-align: center;
  font-size: 0.72rem;
  font-weight: 600;
  line-height: 1.2;
  padding: 5px 8px;
  border-radius: 7px;
  color: inherit;
  opacity: 0.7;
  text-decoration: none;
  transition:
    background-color 0.15s cubic-bezier(0.4, 0, 0.2, 1),
    opacity 0.15s cubic-bezier(0.4, 0, 0.2, 1);

  &:hover,
  &:focus-visible {
    opacity: 1;
    background: rgba(255, 255, 255, 0.06);
  }

  &:focus-visible {
    outline: 2px solid var(--q-primary);
    outline-offset: -2px;
  }

  &.is-current {
    opacity: 1;
    color: var(--q-primary);
    background: color-mix(in srgb, var(--q-primary) 18%, transparent);
  }
}

.sidebar-frontend-switch__mini {
  text-align: center;
  opacity: 0.75;
}

// Scoped `display: flex` outranks Quasar's `.q-drawer--mini .q-mini-drawer-hide`, so hide it here.
.q-drawer--mini .sidebar-frontend-switch__group {
  display: none;
}

.body--light .sidebar-frontend-switch__group {
  background: rgba(0, 0, 0, 0.03);
  border-color: rgba(0, 0, 0, 0.06);
}

.body--light .sidebar-frontend-switch__option:hover,
.body--light .sidebar-frontend-switch__option:focus-visible {
  background: rgba(0, 0, 0, 0.05);
}
</style>
